import { render, staticRenderFns } from "./vue-cropper.vue?vue&type=template&id=3defeb46&scoped=true&"
import script from "./vue-cropper.vue?vue&type=script&lang=js&"
export * from "./vue-cropper.vue?vue&type=script&lang=js&"
import style0 from "./vue-cropper.vue?vue&type=style&index=0&id=3defeb46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3defeb46",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wp/Desktop/chuanti-pc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3defeb46')) {
      api.createRecord('3defeb46', component.options)
    } else {
      api.reload('3defeb46', component.options)
    }
    module.hot.accept("./vue-cropper.vue?vue&type=template&id=3defeb46&scoped=true&", function () {
      api.rerender('3defeb46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/VueImageCropperNew/vue-cropper/vue-cropper.vue"
export default component.exports